var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1653 0C13.2195 4.61631 3.1504 22.0033 0.551271 29.8007C-0.0260896 31.5328 -0.534647 33.429 1.13272 30.4049C2.1321 28.5923 4.60525 26.0409 10.2449 25.1255C14.7566 24.3932 16.6458 23.4418 19.5391 20.2052C18.2052 20.6759 16.4823 21.66 12.8043 20.5321C17.9045 20.9728 21.419 17.9977 22.7921 13.7646C19.4247 15.2685 16.5749 14.2162 15.8284 13.8293C20.4219 13.9431 24.296 11.0674 25.2278 6.27776C25.7709 3.48578 24.9009 0.915404 24.1653 0Z",
    fill: "#6160A2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4887 1.38411C11.6153 7.40871 2.93685 22.644 0.551271 29.8007C-0.0260896 31.5328 -0.534647 33.429 1.13272 30.4049C2.1321 28.5923 4.60525 26.0409 10.2449 25.1255C13.9918 24.5173 15.93 23.758 18.1367 21.6641C18.526 21.2947 18.7399 20.5199 18.229 20.6845C17.6368 20.8753 17.0213 20.0638 17.5917 19.8153C19.3813 19.0356 20.7977 17.7002 21.7876 16.0159C22.2698 15.1954 20.5247 14.4868 19.5736 14.5218C18.4088 14.5646 19.3427 13.2941 20.4298 12.8738C21.8816 12.3125 23.2021 11.5199 24.0672 10.5927C25.1935 9.38541 24.8663 8.13575 25.2278 6.27776C25.4709 5.02789 25.4309 3.82242 25.2464 2.78996C24.9323 1.03116 23.0138 0.453484 21.4887 1.38411Z",
    fill: "#6160A2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.8875,
    cy: 6.54842,
    r: 14.056,
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.8875,
    cy: 6.54842,
    r: 16.556,
    stroke: "#90DF9B",
    strokeWidth: 5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -73.1685,
    y: -76.5076,
    width: 174.112,
    height: 174.112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherIcon);
export default __webpack_public_path__ + "static/media/feather-icon.daf803ada3375a73384e27d9ab8b18ab.svg";
export { ForwardRef as ReactComponent };